@if (actionSection) {
  <div class="wrapper">
    @if (!navChange) {
      <ul class="list-reset has-padding is-stacked level divider nav-bar-zoom nav-bar-height">
        @for (nav of navList; track nav) {
          @if (nav.id == navId) {
            <li routerLink={{nav.routerLink}} routerLinkActive="active"
              class="has-padding has-text-centered pointer" (click)="onClickNavigationLink(nav)"
              [tabIndex]="tabIndexOmit ? -1 : 0" matTooltip="{{nav.name}}" matTooltipPosition="below"
              matTooltipClass="bofa--heading is-7">
              <div class="bofa--heading is-3 zoom-button div-header">
                <svg aria-label="Complete Icon" version="1.1" viewBox="0 0 23 23" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <polygon id="path-1" points="16.131728 18 11.5 15.5845315 6.86827195 18 7.75354108 12.9400099 4 9.33068914 9.18413598 8.59494298 11.5 4 13.815864 8.59494298 19 9.33068914 15.2464589 12.9122459"/>
                  </defs>
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Icons" transform="translate(-327.000000, -401.000000)">
                      <g id="Complete_Icon" transform="translate(327.000000, 401.000000)">
                        <circle id="Oval" fill="#E31837" cx="11.5" cy="11.5" r="11.5"/>
                        <mask id="mask-2" fill="white">
                          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#path-1"/>
                        </mask>
                        <use id="Shape" fill="#FFFFFF" fill-rule="nonzero" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#path-1"/>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <p class="display-none">{{nav.name}}</p>
            </li>
          }
          @if (nav.id > navId) {
            <!-- this one can not have router pointer -->
            <li class="has-padding has-text-centered" matTooltip="{{nav.name}}" matTooltipPosition="below"
              matTooltipClass="bofa--heading is-7">
              <div tabindex="-1" class="dark-blue bofa--heading is-3 zoom-button div-header">
                <svg class="intro-image bofa--heading is-3 icon-text zoom-img" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 25 25" version="1.1" aria-label="Navigate to {{ nav.name }} disabled">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-265.000000, -400.000000)" fill-rule="nonzero" stroke="#CCD3E1">
                      <g transform="translate(82.000000, 150.000000)">
                        <g transform="translate(184.000000, 251.000000)">
                          <path d="M11.5,0.164285714 C5.25024286,0.164285714 0.164285714,5.25024286 0.164285714,11.5 C0.164285714,17.7497571 5.25024286,22.8357143 11.5,22.8357143 C17.7497571,22.8357143 22.8357143,17.7497571 22.8357143,11.5 C22.8357143,5.25024286 17.7497571,0.164285714 11.5,0.164285714 Z"/>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <p class="display-none">{{nav.name}}</p>
            </li>
          }
          @if (lessThan(nav.id)) {
            <li routerLink={{nav.routerLink}} routerLinkActive="active"
              class="has-padding has-text-centered pointer" (keyup.enter)="keyDown(nav)"
              (click)="onClickNavigationLink(nav)" (change)="onClickNavigationLink(nav)"
              [tabIndex]="tabIndexOmit ? -1 : 0" matTooltip="{{nav.name}}" matTooltipPosition="below"
              matTooltipClass="bofa--heading is-7 ">
              <div class="dark-blue bofa--heading is-3 zoom-button div-header">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 23 23" version="1.1" aria-label="Navigate to {{ nav.name }}" class="intro-image bofa--heading is-3 icon-text zoom-img">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-300.000000, -401.000000)" fill-rule="nonzero">
                      <g transform="translate(82.000000, 150.000000)">
                        <g transform="translate(218.000000, 251.000000)">
                          <path d="M11.5,0.164285714 C5.25024286,0.164285714 0.164285714,5.25024286 0.164285714,11.5 C0.164285714,17.7497571 5.25024286,22.8357143 11.5,22.8357143 C17.7497571,22.8357143 22.8357143,17.7497571 22.8357143,11.5 C22.8357143,5.25024286 17.7497571,0.164285714 11.5,0.164285714 Z" fill="#012169"/>
                          <polyline fill="#FFFFFF" points="8.91821899 17 4 12.0304393 4.80190822 11.215795 8.91821899 15.3753138 18.1980918 6 19 6.81464435 8.91821899 17"/>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <p class="display-none">{{nav.name}}</p>
            </li>
          }
        }
      </ul>
    }
    @if (navChange) {
      <nav mat-tab-nav-bar>
        @for (nav of navList; track nav) {
          <a mat-tab-link class="mat-tab-link-zoom opacity"
            [disabled]="tabIndexOmit || nav.id > navId" (keyup.enter)="keyDown(nav)"
            (click)="onClickNavigationLink(nav)" (change)="onClickNavigationLink(nav)" matTooltip="{{nav.name}}"
            matTooltipClass="bofa--heading is-7" matTooltipPosition="below" routerLinkActive="active"
            [active]="nav.id == navId">
            @if (nav.id == navId) {
              <div class="bofa--heading is-3 zoom-button zoom-img div-header">
                <svg aria-label="Complete Icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 23 23" version="1.1" class="intro-image has-background  bofa--heading is-3 zoom-button icon-text">
                  <defs>
                    <polygon points="16.131728 18 11.5 15.5845315 6.86827195 18 7.75354108 12.9400099 4 9.33068914 9.18413598 8.59494298 11.5 4 13.815864 8.59494298 19 9.33068914 15.2464589 12.9122459"/>
                  </defs>
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-327.000000, -401.000000)">
                      <g transform="translate(327.000000, 401.000000)">
                        <circle fill="#E31837" cx="11.5" cy="11.5" r="11.5"/>
                        <mask fill="white">
                          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#path-1"/>
                        </mask>
                        <use fill="#FFFFFF" fill-rule="nonzero" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#path-1"/>
                      </g>
                    </g>
                  </g>
                </svg>
                <p class="display-none">{{nav.name}}</p>
              </div>
            }
            @if (lessThan(nav.id)) {
              <div class="has-padding has-text-centered pointer" tabindex="-1">
                <div tabindex="-1" class="dark-blue bofa--heading is-3 zoom-button zoom-img div-header">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 23 23" version="1.1" aria-label="Navigate to {{ nav.name }}" class="intro-image bofa--heading is-3 icon-text zoom-img">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g transform="translate(-300.000000, -401.000000)" fill-rule="nonzero">
                        <g transform="translate(82.000000, 150.000000)">
                          <g transform="translate(218.000000, 251.000000)">
                            <path d="M11.5,0.164285714 C5.25024286,0.164285714 0.164285714,5.25024286 0.164285714,11.5 C0.164285714,17.7497571 5.25024286,22.8357143 11.5,22.8357143 C17.7497571,22.8357143 22.8357143,17.7497571 22.8357143,11.5 C22.8357143,5.25024286 17.7497571,0.164285714 11.5,0.164285714 Z" fill="#012169"/>
                            <polyline fill="#FFFFFF" points="8.91821899 17 4 12.0304393 4.80190822 11.215795 8.91821899 15.3753138 18.1980918 6 19 6.81464435 8.91821899 17"/>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <p class="display-none">{{nav.name}}</p>
              </div>
            }
            @if (nav.id > navId) {
              <div tabindex="-1" class="pointer-event" class="has-padding has-text-centered">
                <div tabindex="-1" class="dark-blue bofa--heading is-3 zoom-button zoom-img div-header">
                  <svg class="intro-image bofa--heading is-3 icon-text zoom-img" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 25 25" version="1.1" aria-label="{{ nav.name }}">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g transform="translate(-265.000000, -400.000000)" fill-rule="nonzero" stroke="#CCD3E1">
                        <g transform="translate(82.000000, 150.000000)">
                          <g transform="translate(184.000000, 251.000000)">
                            <path d="M11.5,0.164285714 C5.25024286,0.164285714 0.164285714,5.25024286 0.164285714,11.5 C0.164285714,17.7497571 5.25024286,22.8357143 11.5,22.8357143 C17.7497571,22.8357143 22.8357143,17.7497571 22.8357143,11.5 C22.8357143,5.25024286 17.7497571,0.164285714 11.5,0.164285714 Z"/>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <p class="display-none">{{nav.name}}</p>
              </div>
            }
            @if (mobile) {
              <span class="mobile-nav">{{nav.name}}</span>
            }
          </a>
        }
      </nav>
    }
    <mat-divider aria-hidden="true"></mat-divider>
  </div>
}
